import MainLayout from "../components/Layouts/MainLayout";
import Transaction from "../components/transaction";

export default function TransactionPage() {
  return (
    <MainLayout activeId="transactions" isRoomView={true}>
      <Transaction />
    </MainLayout>
  );
}
